module.exports = __webpack_public_path__ + "img/gemic.f8c6c98b.svg";